import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiTableCell from '@mui/material/TableCell';
import MuiTableRow from '@mui/material/TableRow';
import { useSTRows } from '../SmartTableContext';
import { cellStyle, rowStyle } from '../styles';
export function TableBodyRowEmpty({ index, columns }) {
    const { rowsSelectEnabled } = useSTRows();
    return (_jsxs(MuiTableRow, { sx: rowStyle, children: [rowsSelectEnabled && (_jsx(MuiTableCell, { sx: cellStyle, children: _jsx("span", { children: "\u00A0" }) }, `table-cell-${index}-select`)), columns.map((cell) => {
                return (_jsx(MuiTableCell, { sx: cellStyle, children: _jsx("span", { children: "\u00A0" }) }, `table-cell-${index}-${cell.fieldName}`));
            })] }, `table-row-${index}`));
}
//# sourceMappingURL=TableBodyRowEmpty.js.map